export default "__VITE_ASSET__CM1vJuQY__"